



















import Vue from 'vue'

export default Vue.extend({
  props: ['trialCenters'],
  data: () => ({
    selectedCenter: null,
    dialog: false,
  }),
  watch: {
    selectedCenter() {
      this.$emit('selectCenter', this.selectedCenter)
    }
  },
  computed: {
    centers() {
        let centers: any[] = <[]>this.$auth.user?.centers || []
        let trialCenters = this.trialCenters || []
        centers = centers.filter((center: { id: number }) =>
          trialCenters.find(
            (trialCenter: { centerId: number }) =>
              trialCenter.centerId === center.id
          )
        )
        if (centers.length === 1) this.selectedCenter = centers[0]
        return centers
    },
  },
})
